export const getWebSocketUrl = (queryString: string, environmentWsUrl = ''): string => {
    const queryParams = new URLSearchParams(queryString);
    const urlOrFlag = queryParams.get('ws') || '';

    if (!urlOrFlag || urlOrFlag === 'demo') {
        return '';
    }

    const url = urlOrFlag === 'dev' ? environmentWsUrl : urlOrFlag;
    return appendTimestampToUrl(url);
};

const appendTimestampToUrl = (url: string): string => {
    return `${url}${url.endsWith('/') ? '' : '/'}${Date.now()}`;
};
